import '../../../../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min';
import Swiper from './custom-swiper';

export default new class productSlider {
  constructor() {
    this.init();
    const vpState = window.matchMedia('(min-width: 769px)').matches;
    if (vpState) {
      this.initDesktop();
    } else {
      this.initMobile();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  init() {
    $('.fancybox-thumb').fancybox();
  }

  // eslint-disable-next-line class-methods-use-this
  initDesktop() {
    const galleryThumbs = new Swiper('._gallery-thumbs', {
      slidesPerView: 3,
      slidesToScroll: 2,
      spaceBetween: 10,
      direction: 'vertical',
      navigation: {
        nextEl: '._thumb-button-next',
        prevEl: '._thumb-button-prev',
      },
    });
    // eslint-disable-next-line no-unused-vars,sonarjs/no-duplicate-string
    const galleryTop = new Swiper('._gallery-top', {
      slidesToShow: 1,
      slidesToScroll: 1,
      navigation: false,
      allowTouchMove: false,
      asNavFor: '._gallery-thumbs',
      thumbs: {
        swiper: galleryThumbs,
      },
    });

    // eslint-disable-next-line no-unused-vars
    $('._gallery-top').on('afterChange', (event, slick, currentSlide, nextSlide) => {
      // remove all active class
      $('._gallery-thumbs .slick-slide').removeClass('slick-current');
      // set active class for current slide
      $('._gallery-thumbs .slick-slide:not(.slick-cloned)').eq(currentSlide).addClass('slick-current');
    });
  }

  // eslint-disable-next-line class-methods-use-this
  initMobile() {
    // eslint-disable-next-line no-unused-vars
    const galleryTop = new Swiper('._gallery-top', {
      slidesToShow: 1,
      slidesToScroll: 1,
      navigation: false,
      dots: true,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        dynamicBullets: true,
      },
    });
  }
}();
